export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_05.0e0c26bd.png";